export const APP_SWITCHER_SPOTLIGHT_KEY = 'app-switcher-spotlight';
